<template>
  <div id="pincode_page" v-loading="loading">
    <div class="formContainer flex-mid fc-FFFFFF">
      <div class="divContainer2">
        <div class="form-content">
          <div class="center">
            <img
              src="../assets/images/navbar/logo_happily_dark.png"
              class="imgLogo"
              alt="Happily.ai Logo"
            />
          </div>
          <div class="welcome-text">
            {{ $t('pincode.your_verification') }}
            <span class="brand-highlight">PIN code</span>
          </div>
          <div class="subtitle">
            {{ $t('pincode.enter_the_four') }}
          </div>
          <el-form :model="ruleForm2" status-icon ref="ruleForm2" class="form-section">
            <el-form-item prop="pincode" class="formItem">
              <div class="pin-input-container">
                <el-input
                  v-numericOnly
                  class="inputPincode"
                  ref="FirstInput"
                  :disabled="pinSubmitting || loading"
                  maxlength="1"
                  type="text"
                  inputmode="numeric"
                  v-model="ruleForm2.pincode1"
                  @focus="onFirstInputFocus"
                  @keyup.native="onFirstInputChange"
                  @paste.native="handlePaste"
                  autocomplete="one-time-code"
                ></el-input>
                <el-input
                  v-numericOnly
                  class="inputPincode"
                  ref="SecondInput"
                  :disabled="pinSubmitting || loading"
                  maxlength="1"
                  type="text"
                  inputmode="numeric"
                  v-model="ruleForm2.pincode2"
                  @focus="onSecondInputFocus"
                  @keyup.native="onSecondInputChange"
                  autocomplete="one-time-code"
                ></el-input>
                <el-input
                  v-numericOnly
                  class="inputPincode"
                  ref="ThirdInput"
                  :disabled="pinSubmitting || loading"
                  maxlength="1"
                  type="text"
                  inputmode="numeric"
                  v-model="ruleForm2.pincode3"
                  @focus="onThirdInputFocus"
                  @keyup.native="onThirdInputChange"
                  autocomplete="one-time-code"
                ></el-input>
                <el-input
                  v-numericOnly
                  class="inputPincode"
                  ref="ForthInput"
                  :disabled="pinSubmitting || loading"
                  maxlength="1"
                  type="text"
                  inputmode="numeric"
                  v-model="ruleForm2.pincode4"
                  @focus="onForthInputFocus"
                  @keyup.native="onForthInputChange"
                  @keyup.enter.native="submitForm('ruleForm2')"
                  autocomplete="one-time-code"
                ></el-input>
              </div>
            </el-form-item>
            <div style="margin-top: 16px; display: none">
              <el-form-item prop="pass" class="formItem">
                <el-input
                  class="inputPincode"
                  style="margin-left: 8px"
                  type="password"
                  v-model="ruleForm2.passinput"
                  @keyup.enter.native="submitForm('ruleForm2')"
                  placeholder="password"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </div>
            <div class="submit-section">
              <el-form-item class="formItem">
                <el-button
                  class="btnSignIn"
                  type="primary"
                  :disabled="!isPinComplete || pinSubmitting || loading"
                  :loading="pinSubmitting || loading"
                  @click="submitForm('ruleForm2')"
                  >{{ $t('global.submit') }}</el-button
                >
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div v-if="pinErrorMessage" class="error-section">
          <div class="error-title">{{ pinErrorMessage }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "./../router";
import firebase from "firebase/app";
import "firebase/auth";
import Vue from "vue";
Vue.directive("numericOnly", {
  bind(el, binding, vnode) {
    el.addEventListener("keydown", (e) => {
      if ([8].indexOf(e.keyCode) !== -1) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if (
        (e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault();
      }
    });
  },
});
export default {
  created() {
    if (firebase.auth().currentUser && localStorage.getItem("userData")) {
      router.replace("/");
    }
    if (!this.$store.getters["authen/useremail"]) router.replace("/login");
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    error() {
      return this.$store.getters["authen/error"];
    },
    loading() {
      return this.$store.getters["authen/loading"];
    },
    useremail() {
      return this.$store.getters["authen/useremail"];
    },
    // Computed property to check if all PIN digits are filled
    isPinComplete() {
      return this.ruleForm2.pincode1 && 
             this.ruleForm2.pincode2 && 
             this.ruleForm2.pincode3 && 
             this.ruleForm2.pincode4;
    }
  },
  watch: {
    error: function (val) {
      this.showError(val);
    },
    loading: function (val) {
      if (!val) {
        this.pinSubmitting = false;
      }
    },
    useremail: function (val) {
      this.checkUserEmail(val);
    },
    // Watch for when PIN is complete and auto-submit
    isPinComplete: function(val) {
      if (val && !this.pinSubmitting && !this.loading) {
        if (this.autoSubmitTimer) clearTimeout(this.autoSubmitTimer);
        // Small delay to allow user to see the complete PIN before submitting
        this.autoSubmitTimer = setTimeout(() => {
          this.autoSubmitTimer = null;
          this.submitForm('ruleForm2');
        }, 300);
      }
    }
  },
  data() {
    return {
      ruleForm2: {
        pincode1: "",
        pincode2: "",
        pincode3: "",
        pincode4: "",
        checked: true,
      },
      pinSubmitting: false,
      autoSubmitTimer: null,
      pinErrorMessage: "",
    };
  },
  beforeDestroy() {
    if (this.autoSubmitTimer) clearTimeout(this.autoSubmitTimer);
  },
  mounted() {
    this.$refs.FirstInput.select();
  },
  methods: {
    checkUserEmail(val) {
      if (!val) router.replace("/login");
    },
    submitForm(formName) {
      // Only submit if we have all 4 digits
      if (this.isPinComplete && !this.pinSubmitting && !this.loading) {
        this.auth();
      }
    },
    auth() {
      this.pinSubmitting = true;
      this.pinErrorMessage = "";
      this.$store.dispatch("authen/loginpincode", {
        pincode:
          this.ruleForm2.pincode1 +
          this.ruleForm2.pincode2 +
          this.ruleForm2.pincode3 +
          this.ruleForm2.pincode4,
      });
      setTimeout(() => {
        if (this.ruleForm2.pincode1 &&
          this.ruleForm2.pincode2 &&
          this.ruleForm2.pincode3 &&
          this.ruleForm2.pincode4) {
            this.ruleForm2.pincode1 = "";
            this.ruleForm2.pincode2 = "";
            this.ruleForm2.pincode3 = "";
            this.ruleForm2.pincode4 = "";
            this.$refs.FirstInput.select();
          }
      }, 1400)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    showError(message) {
      this.pinSubmitting = false;
      if (message) {
        this.pinErrorMessage = message;
        this.$message({
          showClose: true,
          message,
          type: "error",
          duration: 4000,
        });
        setTimeout(() => {
          this.$store.dispatch("authen/clearError");
        }, 1000);
      }
    },
    // Handle paste functionality
    handlePaste(e) {
      e.preventDefault();
      const pastedData = e.clipboardData.getData('text');
      const digits = pastedData.replace(/\D/g, '').substring(0, 4); // Only keep digits, max 4
      
      if (digits.length > 0) {
        // Fill the inputs with the pasted digits
        this.ruleForm2.pincode1 = digits[0] || '';
        this.ruleForm2.pincode2 = digits[1] || '';
        this.ruleForm2.pincode3 = digits[2] || '';
        this.ruleForm2.pincode4 = digits[3] || '';
        
        // Focus the next empty input or the last one if all are filled
        if (digits.length === 1) this.$refs.SecondInput.select();
        else if (digits.length === 2) this.$refs.ThirdInput.select();
        else if (digits.length === 3) this.$refs.ForthInput.select();
        else if (digits.length === 4) this.$refs.ForthInput.select();
      }
    },
    onFirstInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value)) {
        if (this.$refs.FirstInput.value) this.$refs.SecondInput.select();
      }
    },
    onSecondInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value)) {
        if (this.$refs.SecondInput.value) this.$refs.ThirdInput.select();
      } else {
        this.$refs.FirstInput.select();
      }
    },
    onThirdInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value)) {
        if (this.$refs.ThirdInput.value) this.$refs.ForthInput.select();
      } else {
        this.$refs.SecondInput.select();
      }
    },
    onForthInputChange(e) {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value)) {
        // Auto-submit will be handled by the watcher
      } else {
        if (!this.$refs.ForthInput.value) this.$refs.ThirdInput.select();
      }
    },
    onFirstInputFocus() {
      if (this.$refs.FirstInput.value) this.$refs.FirstInput.select();
    },
    onSecondInputFocus() {
      if (this.$refs.SecondInput.value) this.$refs.SecondInput.select();
    },
    onThirdInputFocus() {
      if (this.$refs.ThirdInput.value) this.$refs.ThirdInput.select();
    },
    onForthInputFocus() {
      if (this.$refs.ForthInput.value) this.$refs.ForthInput.select();
    },
  },
};
</script>


<style lang="scss" scoped>
.formContainer {
  min-height: 100vh;
  height: calc(100vh);
  background: linear-gradient(135deg, #6c30cc 0%, #5a28b8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.divContainer2 {
  width: 100%;
  max-width: 520px;
  background: rgba(17, 17, 17, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
  }
}

.form-content {
  padding: 48px 40px 32px 40px;
  
  @media (max-width: 768px) {
    padding: 32px 24px 24px 24px;
  }
}

.imgLogo {
  height: 64px;
  width: auto;
  margin-bottom: 16px;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.2));
}

.welcome-text {
  font-size: 28px;
  font-weight: 800;
  margin-top: 32px;
  margin-bottom: 8px;
  text-align: center;
  color: #ffffff;
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 24px;
    margin-top: 24px;
  }
}

.brand-highlight {
  color: #FBC02D;
  background: linear-gradient(45deg, #FBC02D, #FFD54F);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  margin-bottom: 40px;
  line-height: 1.4;
}

.form-section {
  margin-top: 24px;
}

.formItem {
  width: 100%;
}

.pin-input-container {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 32px;
  
  @media (max-width: 480px) {
    gap: 12px;
  }
}

.submit-section {
  margin-top: 40px;
}

.btnSignIn {
  width: 100%;
  height: 52px;
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(135deg, #32C2D5 0%, #28a8b8 100%);
  border: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(50, 194, 213, 0.3);
  
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(50, 194, 213, 0.4);
    background: linear-gradient(135deg, #28a8b8 0%, #32C2D5 100%);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 2px 8px rgba(50, 194, 213, 0.2);
  }
}

.error-section {
  margin: 24px 32px 32px 32px;
  padding: 20px 24px;
  border-radius: 8px;
  background: linear-gradient(135deg, #F44336 0%, #d32f2f 100%);
  color: #ffffff;
  text-align: center;
  font-size: 14px;
  box-shadow: 0 4px 16px rgba(244, 67, 54, 0.3);
  
  @media (max-width: 768px) {
    margin: 16px 24px 24px 24px;
    padding: 16px 20px;
  }
}

.error-title {
  font-weight: 700;
  margin-bottom: 4px;
}

</style>

<style lang="scss">
#pincode_page {
  .el-input__inner {
    background-color: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    border: 2px solid rgba(255, 255, 255, 0.2);
    transition: all 0.3s ease;
    border-radius: 8px;
  }
  
  .inputPincode.el-input {
    width: 72px;
    
    @media (max-width: 480px) {
      width: 64px;
    }
    
    > input.el-input__inner {
      height: 72px;
      font-size: 32px;
      font-weight: 700;
      text-align: center;
      background-color: rgba(255, 255, 255, 0.1);
      border: 2px solid rgba(255, 255, 255, 0.2);
      border-radius: 12px;
      transition: all 0.3s ease;
      color: #ffffff;
      
      @media (max-width: 480px) {
        height: 64px;
        font-size: 28px;
        border-radius: 8px;
      }
      
      &:focus {
        color: #ffffff;
        border-color: #32C2D5;
        background-color: rgba(0, 0, 0, 0.25);
        box-shadow: 0 0 0 3px rgba(50, 194, 213, 0.1);
        outline: none;
        transform: scale(1.05);
      }
      
      &:hover:not(:focus) {
        border-color: rgba(255, 255, 255, 0.3);
        background-color: rgba(0, 0, 0, 0.15);
      }
      
      // Better contrast when field has value
      &:not(:placeholder-shown) {
        background-color: rgba(0, 0, 0, 0.2);
        border-color: rgba(50, 194, 213, 0.4);
        color: #ffffff;
      }
    }
  }
  
  .el-loading-mask {
    background-color: rgba(108, 48, 204, 0.8);
    backdrop-filter: blur(4px);
  }
}
</style>
